import cn from 'classnames'
import { useMemo } from 'react'

import { GrowField } from '../../../components/GrowField'
import { SOB_FRACTION_DIGITS } from '../../config'

import { IExtraRowsProps } from './models/IExtraRowsProps'

import styles from './ExtraSobRows.module.scss'

interface IExtraSobRowsProps extends IExtraRowsProps {
  isHideCurrTargetsYoY: boolean
  isCalc: boolean
}

export const ExtraSobRows = ({
  isPlanningByFY,
  isHideCurrTargetsYoY,
  isCalc,

  isShowYoYActualsVsActuals,
  isShowYoYActualsVsPlans,
  isShowYoYPlansVsPlans,

  isShowQoQActualsVsActuals,
  isShowQoQActualsVsPlans,
  isShowQoQPlansVsPlans,

  yoyActuals,
  yoyTargets,
  yoyPlans,

  qoqActuals,
  qoqTargets,
  qoqPlans,
}: IExtraSobRowsProps) => {
  /** -------------------- Variables ----------------------- */

  const isShowAnyYoY = useMemo(() => {
    return isShowYoYActualsVsActuals || isShowYoYActualsVsPlans || isShowYoYPlansVsPlans
  }, [isShowYoYActualsVsActuals, isShowYoYActualsVsPlans, isShowYoYPlansVsPlans])

  const isShowAnyQoQ = useMemo(() => {
    return isShowQoQActualsVsActuals || isShowQoQActualsVsPlans || isShowQoQPlansVsPlans
  }, [isShowQoQActualsVsActuals, isShowQoQActualsVsPlans, isShowQoQPlansVsPlans])

  /** -------------------- Render ----------------------- */

  return (
    <div className={cn({ [styles.yoyBlock]: isShowAnyYoY })}>
      <div>
        {isShowYoYActualsVsActuals && (
          <GrowField
            percent={yoyActuals}
            fractionDigits={SOB_FRACTION_DIGITS}
            isPaleColor={true}
            diff
          />
        )}
        {isShowYoYActualsVsPlans && (
          <>
            {isHideCurrTargetsYoY ? (
              <span>&nbsp;</span>
            ) : (
              <GrowField percent={yoyTargets} fractionDigits={SOB_FRACTION_DIGITS} diff />
            )}
          </>
        )}
        {isShowYoYPlansVsPlans && (
          <GrowField percent={yoyPlans} fractionDigits={SOB_FRACTION_DIGITS} diff />
        )}
      </div>
      {isCalc || isPlanningByFY ? (
        <div className={cn({ [styles.yoyBlock]: isShowAnyQoQ })}>
          {isShowQoQActualsVsActuals && <div>&nbsp;</div>}
          {isShowQoQActualsVsPlans && <div>&nbsp;</div>}
          {isShowQoQPlansVsPlans && <div>&nbsp;</div>}
        </div>
      ) : (
        <div className={cn({ [styles.yoyBlock]: isShowAnyQoQ })}>
          {isShowQoQActualsVsActuals && (
            <GrowField
              percent={qoqActuals}
              fractionDigits={SOB_FRACTION_DIGITS}
              isPaleColor={true}
              diff
            />
          )}
          {isShowQoQActualsVsPlans && (
            <GrowField percent={qoqTargets} fractionDigits={SOB_FRACTION_DIGITS} diff />
          )}
          {isShowQoQPlansVsPlans && (
            <GrowField percent={qoqPlans} fractionDigits={SOB_FRACTION_DIGITS} diff />
          )}
        </div>
      )}
    </div>
  )
}
